import { http, HttpResponse } from 'msw'

import { getResponseObject } from '@webapp/tests/getResponseObject'
import { type AuditLogRecordApiModel } from '../api-models/AuditLogRecordApiModel'
import { AuditLogRecordApiModelStub } from '../api-models/stubs/AuditLogRecordApiModel.stub'

export const mockGetAuditLog = (
  contentTypeId: number,
  objectId: string,
  data: AuditLogRecordApiModel[] = AuditLogRecordApiModelStub.buildList(1),
  pagination = {},
  metadata = {}
) => {
  return http.get(
    `/api/v3/audit/${contentTypeId}/${objectId}/`,
    () => {
      return HttpResponse.json(getResponseObject(data, pagination, metadata), {
        status: 200,
      })
    },
    { once: true }
  )
}
